


export enum EAppLanguages {
    FI = "fi",
    EN = "en"
};

export type TDefaultAppLanguage = EAppLanguages.FI;

export const langToAppLanguage = (rawLang: string) => {
    switch (rawLang) {
        case "fi":
            return EAppLanguages.FI;
        case "en":
            return EAppLanguages.EN;
        case "us":
            return EAppLanguages.EN;
    }
    return EAppLanguages.FI;
}


export type TTranslations<TBase extends { [key: string]: string },> = {
    [key in EAppLanguages]: {
        translations: TBase //  T[TDefaultAppLanguage]["translation"]
    }
};
